"use client";
import {
  createTheme,
  ThemeProvider as ThemeProviderMui,
} from "@mui/material/styles";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

const lightTheme = createTheme({
  palette: {
    mode: "light",
  },
});

interface Props {
  children: React.ReactNode;
  mode: "light" | "dark";
}

export const ThemeProvider: React.FC<Props> = ({ children, mode }) => {
  return (
    <ThemeProviderMui theme={mode === "dark" ? darkTheme : lightTheme}>
      {children}
    </ThemeProviderMui>
  );
};
